import '@app/yup.config';
import cssVars from 'css-vars-ponyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

import pt from 'date-fns/locale/pt';
import { registerLocale } from 'react-datepicker';
import { ErrorBoundary } from '@components';
import Router from './routes/Router';

// Compatibilidade
import reportWebVitals from './reportWebVitals';
import store from './store';

cssVars();

registerLocale('pt', pt);

Modal.setAppElement('#root');

ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <React.StrictMode>
        <BrowserRouter>
          <ToastContainer autoClose={5000} />
          <Router />
        </BrowserRouter>
      </React.StrictMode>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
